import { createContext, useContext, type ReactNode } from 'react'
import { services, type AppServices } from '@/config/services'

// Makes the composition root's repositories/services available to any
// component via useServices(). UI components must go through this hook —
// never import LocalEpisodeRepository / localStorage / DevAuthProvider
// directly (Document 11 §technical rule).
const ServiceContext = createContext<AppServices>(services)

export function ServiceProvider({ children }: { children: ReactNode }) {
  return <ServiceContext.Provider value={services}>{children}</ServiceContext.Provider>
}

export function useServices(): AppServices {
  return useContext(ServiceContext)
}
